module.exports = __webpack_public_path__ + "img/micphone_off.7327491b.png";